import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { isAuthPageAtom } from "../config/AppConfig";
import { useAtom } from "jotai";
import { Box } from "@mui/material";

export const BackButtonListener = ({ children }) => {
  const location = useLocation();
  const { hash, pathname, search } = location;
  const navigate = useNavigate();

  const [pressed, setPressed] = React.useState(false);
  const [isAuthPage, setAuthStatus] = useAtom(isAuthPageAtom);

  React.useEffect(() => {
    window.onpopstate = (e) => {
      setPressed(true);
     
      if (!isAuthPage && pathname === "/") {
        setAuthStatus(true);
       
      } else if (
        (isAuthPage && pathname === "/") ||
        (isAuthPage && pathname === "/")
      ) {
        navigate("/");
       
      } else {
        setAuthStatus(false);
       
      }
    };
  });

  return (
    <Box>
      {/* <div>Pathname: <b>{pathname}</b><br />
      Search params: <b>{search}</b><br />
      Hash: <b>{hash}</b></div>
      <h3>Back button: {pressed.toString()}</h3> */}
    </Box>
  );
};
